import style from './footer.module.css'
const Footer = () => {
  function doMailTo(){
    var email = "fundacion@fundacionbaviera.org";
    window.open("mailto:" + email);
  };
  return (
    <footer className={style.footer_container_main_class}>
      <p className={style.text_footer_info_class}>Para cualquier duda relacionada con donaciones escríbenos a
      </p>
      <p className={style.link_email_footer_style} onClick={doMailTo}>fundacion@fundacionbaviera.org</p>
    </footer>
  ) 
}

export default Footer
